import { configureStore } from "@reduxjs/toolkit";
import { api } from "../services/api";
import authReducer from "../features/auth/authSlice";
import tenantReducer from "../features/tenant/tenantSlice";
import dashboardReducer from "../features/dashboard/dashboardSlice";
import quizReducer from "../features/quiz/quizSlice";
import toastReducer from "../features/toast/toastSlice";

export const store = configureStore({
    reducer: {
        auth: authReducer,
        tenant: tenantReducer,
        dashboard: dashboardReducer,
        quiz: quizReducer,
        toast: toastReducer,
        [api.reducerPath]: api.reducer
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }).concat(api.middleware)
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
